import React from "react";
import { StyledTextArea, StyledContainer, Label } from "./styles";

export interface InputProps {
  name: string;
  placeholder: string;
  type?: string;
  value?: string;
  disabled?: boolean;
  withTitle?: boolean;
  onChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
}

const CustomTextArea = ({ name, placeholder, onChange, withTitle, value, disabled, type }: InputProps) => (
  <StyledContainer>
    {withTitle && (
      <Label htmlFor={name}>{name}</Label>
    )}

    <StyledTextArea
      placeholder={placeholder}
      id={name}
      name={name}
      onChange={onChange}
      value={value ?? ""} 
      disabled={disabled}
    />
  </StyledContainer>
);

export default CustomTextArea;
